import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class PopupResend extends Vue {
  get message() {
    return this.$store.state.popUpMessage;
  }

  get windowWidth() {
    return window.innerWidth;
  }

  get reducewidthBy() {
    if (this.windowWidth < 500) return 0.8;
    return 0.5;
  }

  statusMsg = "";
  async resendVerification() {
    this.statusMsg = "";
    if (this.emailToBeVerified) {
      const { response, error } = await this.$api.resendVerifyApi(
        this.emailToBeVerified
      );
      if (error) {
        this.statusMsg = this.$t("forms.error.some-went-wrong") as string;
        return;
      }

      if (response) {
        if (response.data.fail) {
          this.statusMsg = response.data.fail;
          return;
        } else if (response.data.success) {
          this.statusMsg = this.$t("verifi-email-sent") as string;
          return;
        }
      }
    }
  }

  get emailToBeVerified() {
    return this.$store.state.emailToBeVerified;
  }
  get triggerredFromRegister() {
    return this.$store.state.triggerredFromRegister;
  }

  closeModal() {
    this.$modal.hide("resend-pop-up");
    this.$store.commit("setEmailToBeVerified", { email: null });
  }

  opened() {
    window.addEventListener("resize", this.changeWidth);
  }

  beforeClosed() {
    window.removeEventListener("resize", this.changeWidth);
  }

  changeWidth() {
    const windowWidth = window.innerWidth;
    let reducewidthBy = 0.8;
    if (windowWidth > 500) {
      reducewidthBy = 0.5;
    }

    if (this.$refs.modal) {
      (this.$refs.modal as any).modal.width = windowWidth * reducewidthBy;
    }
  }
}
